import ComponentName from '@Constant/componentName'
import { UPPER_MARK, UPPER_PAGE_MARK, LIVE_UPPER_MARK } from '@Constant/behaviorTrack'

const upper = [
  {
    component: () => import('../../views/layout/Index.vue'),
    path: '/upper',
    name: ComponentName.upper.home,
    auth: '*',
    children: [
      {
        component: () => import('../../views/upper/square/NewIndex/Index.vue'),
        path: 'index',
        name: ComponentName.upper.index,
        auth: '*',
        meta: {
          title: 'up主列表',
          logAuto: {
            pv: true,
            duration: true,
            source: UPPER_MARK.PV
          }
        }
      },
      {
        component: () => import('../../views/upper/square/LiveIndex/Index.vue'),
        path: 'live',
        name: ComponentName.upper.liveIndex,
        auth: '*',
        meta: {
          title: '直播UP主列表',
          logAuto: {
            pv: true,
            duration: true,
            source: LIVE_UPPER_MARK.PV
          }
        }
      },
      {
        component: () => import('../../views/upper/home/Index.vue'),
        path: 'page/:id',
        name: ComponentName.upper.homePage,
        props: true,
        meta: {
          title: 'up主个人主页',
          log: {
            // 有extra参数，需要走手动埋点
            pv: true,
            duration: true,
            source: UPPER_PAGE_MARK.PV,
            reportQuery: ['referer']
          }
        }
      },
      {
        component: () => import('../../views/upper/liveHome/Index.vue'),
        path: 'live/:id',
        name: ComponentName.upper.liveHomePage,
        props: true,
        meta: {
          title: '直播up主个人主页'
        }
      },
      {
        component: () => import('../../views/upper/PrivateMessage.vue'),
        path: 'private/:mid',
        name: ComponentName.upper.privateMsg,
        props: true,
        meta: {
          title: 'up主私信'
        }
      },
      {
        component: () => import('@/views/upper/liveOrderSeek/index.vue'),
        path: 'live-seek',
        name: ComponentName.upper.liveOrderSeek,
        props: true,
        meta: {
          title: '询单'
        }
      }
    ]
  }
]

export default upper
